<template>
  <div class="form-control">
    <div v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de submenú</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los submenú</option>        
        <option v-for="(submenu,index) in submenus" :value="submenu.SubmenuId" :key="index">{{submenu.Titulo}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        submenus: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo 006Submenus
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }

        this.$store.dispatch("A_SICPO_Catalogos_establecer006Submenus",valoresDelCatalogo);
        let menuObjSeleccionado = this.submenus.find(sm => sm.SubmenuId == evento.target.value);
        this.$emit("valorParaElPadre",evento,menuObjSeleccionado);
        // para obtener label del select => let labelTipoPagina = evento.target.options[evento.target.selectedIndex].text;
      },
      /**
       * Metodo para lenar catalogo 006Submenus mediante el llamado de la API
       */
      cargarSubmenus: function() {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SICPO.catalogos.C006Submenus;
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        let peticionMetodoGetPaginasWebAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);

        axios.post(urlApi, peticionMetodoGetPaginasWebAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        /* utilizar solo en etapa de desarrollo 
                        console.log("ejecuto bien paginas controller:: ",respuesta.data); */
                        this.submenus = respuesta.data.Submenus;
                    }
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
      // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SICPO_Catalogos_establecer006Submenus", valoresDelCatalogo);
    },
    created() {
      this.cargarSubmenus();
    }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SICPO/Catalogos/C006Submenus.vue